module.exports = __webpack_public_path__ + "media/images/favicon-96eb39245ecc30d3d98f8b7ca1e251c5.png";